import { useAppConfigSessionStore, useEnvConfigSessionStore } from '../../stores';

export const useAppEnvConfig = () => {
  const { env, setEnv } = useEnvConfigSessionStore();
  const { appConfig, initializeAppConfig, updateAppConfig } = useAppConfigSessionStore();
  return { appConfig, env, initializeAppConfig, setEnv, updateAppConfig };
};
